import 'react';
import 'react-dom';

import React from 'react';
import {render} from 'react-dom';

import {NewsletterBottom} from '../components/Newsletter';

import Authentication from '../components/Authentication';

import {IntlProvider} from 'react-intl'

window.LPD = window.LPD || {};

window.LPD.newsletter_bottom = {
    init(containerId, source = 'widget', advertiser = '', category = '') {
        render(
            <IntlProvider locale={process.env.LOCALE.replace('_', '-')} messages={process.env.MESSAGES}>
                <div className="__lpd_widget_newsletter_bottom">
                    <Authentication>
                        <NewsletterBottom source={source} advertiser={advertiser} category={category}/>
                    </Authentication>
                </div>
            </IntlProvider>, document.getElementById(containerId || 'lpd-newsletter-bottom'));
    }
};
